import { projectNo } from "../_config";

// Helper function to resize the image
export const resizeImage = (file, w, h) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        const reader = new FileReader();

        reader.onload = (e) => {
            img.onload = () => {
                let canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                if (projectNo === 'MUJems') {
                    const newWidth = 246;
                    const newHeight = 315;

                    canvas.width = newWidth;
                    canvas.height = newHeight;

                    ctx.drawImage(img, 0, 0, newWidth, newHeight);

                } else if (projectNo === 'Shrija') {
                    const fixedSize = 512;

                    canvas.width = fixedSize;
                    canvas.height = fixedSize;

                    ctx.drawImage(img, 0, 0, fixedSize, fixedSize);
                } else if (projectNo === 'GAILEE') {
                    const fixedW = w || 512;
                    const fixedH = h || 512;

                    canvas.width = fixedW;
                    canvas.height = fixedH;

                    ctx.drawImage(img, 0, 0, fixedW, fixedH);
                } else {
                    const fixedSize = 512;

                    canvas.width = fixedSize;
                    canvas.height = fixedSize;

                    ctx.drawImage(img, 0, 0, fixedSize, fixedSize);
                }

                canvas.toBlob((blob) => {
                    const resizedFile = new File([blob], file.name, { type: file.type });
                    resolve(resizedFile);
                }, file.type);
            };
            img.src = e.target.result;
        };

        reader.readAsDataURL(file);
    });
};



// MU Gems image size
// export const resizeImage = (file) => {
//     return new Promise((resolve, reject) => {
//         const img = new Image();
//         const reader = new FileReader();

//         reader.onload = (e) => {
//             img.onload = () => {
//                 let canvas = document.createElement('canvas');
//                 const ctx = canvas.getContext('2d');

//                 const newWidth = 246;
//                 const newHeight = 315;

//                 canvas.width = newWidth;
//                 canvas.height = newHeight;

//                 ctx.drawImage(img, 0, 0, newWidth, newHeight);

//                 canvas.toBlob((blob) => {
//                     const resizedFile = new File([blob], file.name, { type: file.type });
//                     resolve(resizedFile);
//                 }, file.type);
//             };
//             img.src = e.target.result;
//         };

//         reader.readAsDataURL(file);
//     });
// };
